import { Group, Text } from '@mantine/core';
import { prettySizes, prettyUnits } from '@/utils/sizeUtils';

export const Dimentsions = ({
  dimension,
}: {
  dimension: {
    x: number;
    y: number;
    z: number;
  };
}) => {
  return (
    <Group>
      <Group gap='xs'>
        <Text c='gray.6' size='sm'>
          X:
        </Text>
        <Text size='sm'>{`${prettySizes(dimension.x, false)} ${prettyUnits(dimension.x)}`}</Text>
      </Group>
      <Group gap='xs'>
        <Text c='gray.6' size='sm'>
          Y:
        </Text>
        <Text size='sm'>{`${prettySizes(dimension.y, false)} ${prettyUnits(dimension.y)}`}</Text>
      </Group>
      <Group gap='xs'>
        <Text c='gray.6' size='sm'>
          Z:
        </Text>
        <Text size='sm'>{`${prettySizes(dimension.z, false)} ${prettyUnits(dimension.z)}`}</Text>
      </Group>
    </Group>
  );
};
